export const PACK_SURGICAL_GUIDE = 'pack_surgical_guide'

export const PRINT_SURGICAL_GUIDE = 'print_surgical_guide'

export const NESTING_SURGICAL_GUIDE = 'nesting_surgical_guide'

export const SHIP_SURGICAL_GUIDE = 'ship_surgical_guide'

export const FIT_GUIDE = 'fit_guide'

export const MARKING_AND_EXPORT = 'marking_and_export'

export const IMPLANT_SURGERY = 'implant_surgery'



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/implant-treatment/task-name.js